import { Component, OnInit } from '@angular/core';
import 'rxjs/operators/filter';
import 'rxjs/operators/map';
@Component({
  selector: 'home',  // <home></home>
  styleUrls: [ './home.component.scss' ],
  templateUrl: './home.component.html'
})
export class HomeComponent {
    
}